/* document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.product__nav a[data-reference-name]');
    buttons.forEach(button => {
        const referenceName = button.getAttribute('data-reference-name');
        // Encuentra el h2 cuyo texto coincide con data-reference-name
        const matchingH2 = Array.from(document.querySelectorAll('h2'))
            .find(h2 => h2.textContent.trim() === referenceName);
        if (matchingH2) {
            const section = matchingH2.closest('section[id^="shopify-section-template-"]') || matchingH2.closest('details');
            if (section) {
                button.setAttribute('href', `#${section.id}`);
                console.log(`Actualizado href de botón con referencia "${referenceName}" a "#${section.id}"`);
                button.addEventListener('click', event => {
                    event.preventDefault();
                    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                    const offset = 100;
                    window.scrollTo({
                        top: sectionTop - offset,
                        behavior: 'smooth'
                    });
                });
            } else {
                console.log(`No se encontró una sección para el h2 con referencia "${referenceName}"`);
            }
        } else {
            console.log(`No se encontró un h2 con el contenido "${referenceName}"`);
        }
    });

    const productNav = document.querySelector('.product__nav');
    const headerMainWrapper = document.querySelector('sticky-header.header-wrapper');

    if (productNav && headerMainWrapper) {
        const headerHeight = headerMainWrapper.offsetHeight;
        console.log("------------------found element headee", headerHeight);

        window.addEventListener('scroll', () => {
            if (true) {
                if (window.scrollY > 500) {
                    productNav.classList.add('fixed-nav');
                    productNav.style.top = `${headerHeight - 5}px`;
                } else {
                    productNav.classList.remove('fixed-nav');
                    productNav.style.top = '';
                }
            }
        });
    }
})
 */

/* document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.product__nav a[data-reference-name]');

    buttons.forEach(button => {
        const referenceName = button.getAttribute('data-reference-name')?.trim().toLowerCase();
        const isDropdown = button.hasAttribute('data-reference-dropdown');

        // Buscar todos los h2 y normalizar su texto
        const matchingH2 = Array.from(document.querySelectorAll('h2')).find(h2 => {
            const h2Text = h2.textContent?.trim().toLowerCase();
            return h2Text === referenceName;
        });

        if (matchingH2) {
            // Dependiendo del atributo, buscar section o details
            const container = isDropdown
                ? matchingH2.closest('details')
                : matchingH2.closest('section[id^="shopify-section-template-"]');

            if (container && container.id) {
                button.setAttribute('href', `#${container.id}`);
                console.log(`✔️ Actualizado href de "${referenceName}" a "#${container.id}"`);

                button.addEventListener('click', event => {
                    event.preventDefault();

                    const offset = 100;
                    const sectionTop = container.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: sectionTop - offset,
                        behavior: 'smooth'
                    });

                    // Si es dropdown y está cerrado, ábrelo
                    if (isDropdown && container.hasAttribute('open') === false) {
                        container.setAttribute('open', true);
                    }
                });

            } else {
                console.warn(`⚠️ No se encontró contenedor válido para "${referenceName}"`);
            }
        } else {
            console.warn(`❌ No se encontró un <h2> con contenido "${referenceName}"`);
        }
    });

    // Sticky nav en scroll
    const productNav = document.querySelector('.product__nav');
    const headerMainWrapper = document.querySelector('sticky-header.header-wrapper');

    if (productNav && headerMainWrapper) {
        const headerHeight = headerMainWrapper.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.scrollY > 500) {
                productNav.classList.add('fixed-nav');
                productNav.style.top = `${headerHeight - 5}px`;
            } else {
                productNav.classList.remove('fixed-nav');
                productNav.style.top = '';
            }
        });
    }
});
 */


document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.product__nav a[data-reference-name]');

    buttons.forEach(button => {
        const referenceName = button.getAttribute('data-reference-name')?.trim().toLowerCase();
        const isDropdown = button.hasAttribute('data-reference-dropdown');

        // Buscar todos los h2 y comparar con data-title (preferido) o fallback a textContent
        const matchingH2 = Array.from(document.querySelectorAll('h2')).find(h2 => {
            const dataTitle = h2.getAttribute('data-title')?.trim().toLowerCase();
            const h2Text = h2.textContent?.trim().toLowerCase();
            return dataTitle === referenceName || h2Text === referenceName;
        });

        if (matchingH2) {
            // Determinar contenedor
            const container = isDropdown
                ? matchingH2.closest('details')
                : matchingH2.closest('section[id^="shopify-section-template-"]');

            if (container) {
                // Asegurar que tenga un ID para poder hacer scroll
                /* if (!container.id) {
                    container.id = `section-${referenceName}`;
                } */

                button.setAttribute('href', `#${container.id}`);
                console.log(`✔️ Vinculado: ${referenceName} -> #${container.id}`);

                button.addEventListener('click', event => {
                    event.preventDefault();
                    const offset = 100;
                    const sectionTop = container.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: sectionTop - offset,
                        behavior: 'smooth'
                    });

                    if (isDropdown && container.hasAttribute('open') === false) {
                        container.setAttribute('open', true);
                    }
                });
            } else {
                console.warn(`⚠️ No se encontró contenedor para ${referenceName}`);
            }
        } else {
            console.warn(`❌ No se encontró <h2> con data-title o texto igual a "${referenceName}"`);
        }
    });

    // Sticky nav en scroll
    const productNav = document.querySelector('.product__nav');
    const headerMainWrapper = document.querySelector('sticky-header.header-wrapper');

    if (productNav && headerMainWrapper) {
        const headerHeight = headerMainWrapper.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.scrollY > 500) {
                productNav.classList.add('fixed-nav');
                productNav.style.top = `${headerHeight - 5}px`;
            } else {
                productNav.classList.remove('fixed-nav');
                productNav.style.top = '';
            }
        });
    }
});
